class OverlappedMultirow extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Connected Callback Hook
   * Is called when the component is inserted into the DOM
   */
  connectedCallback() {
    // Check if the component is actually connected to the DOM
    if (!this.connectedCallback) return;

    // Component ref
    this.DOMBody = document.querySelector("body");

    // Component event listener
    this.addEventListener("click", this.componentEventHandler.bind(this));
  }

  /**
   * Disconnected Callback Hook
   * Called when the component is removed from the DOM
   */
  disconnectedCallback() {
    this.removeEventListener(
      "click",
      this.componentEventHandler.bind(this),
      true
    );
  }

  /**
   * Event handler for click events
   * @param {Event} event Component click event object
   */
  componentEventHandler(event) {
    const image = event.target.closest(".overlapped-row__image");
    const overlay = event.target.closest(".overlapped-video-layout");

    // Image actions
    if (image) {
      const { videoId } = image.dataset;
      if (!videoId) return;
      this.openVideo(videoId);
      return;
    }

    // Overlay actions
    if (overlay) {
      const { videoId } = overlay.dataset;
      if (!videoId) return;
      this.closeVideo(videoId);
      return;
    }
  }

  /**
   * Open Video by id
   * @param {String} videoId
   */
  openVideo(videoId = "") {
    this.DOMBody.classList.add("overflow-hidden");
    this.querySelector(
      `#overlapped-video-${videoId}`
    ).dataset.showOverlappedVideo = true;
  }

  /**
   * Close video by id
   * @param {String} videoId
   */
  closeVideo(videoId = "") {
    const overlappedVideoContainer = this.querySelector(
      `#overlapped-video-${videoId}`
    );
    this.pauseVideo(overlappedVideoContainer);
    overlappedVideoContainer.dataset.showOverlappedVideo = false;
    this.DOMBody.classList.remove("overflow-hidden");
  }

  /**
   * Pause video
   * Passed row container HTML to target iframe
   * @param {HTML} container
   */
  pauseVideo(container) {
    const iframe = container.querySelector("iframe");
    const src = iframe.src;
    iframe.src = src;
  }
}

customElements.define("overlapped-multirow", OverlappedMultirow);
